
import React, { useState } from 'react';
import Select from 'react-select';
import i18next from 'i18next';
import { selectStyle } from '../styles/selectStyle'
import { useSelector } from 'react-redux';

const languages = [
    { value: 'en-EN', label: 'English' },
    { value: 'es-ES', label: 'Español' },
    { value: 'fr-FR', label: 'Français' },
    { value: 'de-DE', label: 'Deutsch' },
    { value: 'zh-CN', label: '中文(简体)' },
    { value: 'ja-JA', label: '日本語' }
]

const LanguageSwitcher = () => {
    const CAFeLanguages = useSelector(store => store.settings.languages || [])

    const [language, setLanguage] = useState(i18next.language)

    const handleLanguageChange = (lang) => {
        i18next.changeLanguage(lang.value.split('-')[0])
        setLanguage(lang.value)
    }

    const selectableLanguages = languages
        .filter(l => CAFeLanguages
            .some(cl => l.value
                .includes(cl)))

    return CAFeLanguages.length > 1 && (
        <Select
            styles={selectStyle}
            isClearable={false}
            isSearchable={false}
            onChange={handleLanguageChange}
            placeholder="Change Language"
            options={selectableLanguages}
            value={languages.find(e => e.value.startsWith(language))}
        >
        </Select>
    )
}    

export default LanguageSwitcher
